/* =============================================================================
   Eterno Grafiche — Configuratore Ricordini v3.0
   ============================================================================= */

(function () {
  'use strict';

  const ALL_STEPS = ['tipo-formato','grafica','checkout'];

  const FORMAT_RATIO = {
    '5x8 cm':   5/8,
    '6x9 cm':   6/9,
    '7x10 cm':  7/10,
    '8x11 cm':  8/11,
    '9x12 cm':  9/12,
    '10x15 cm': 10/15,
  };

  const FORMAT_SIZE_CLASS = {
    '5x8 cm':    'conf-preview--fmt-sm',
    '6x9 cm':    'conf-preview--fmt-sm',
    '7x10 cm':   'conf-preview--fmt-md',
    '8x11 cm':   'conf-preview--fmt-md',
    '9x12 cm':   '',
    '10x15 cm':  '',
  };

  const LS_KEY = 'eterno_conf_v4';

  // Limite Shopify per upload immagine come line item property (via /cart/add
  // multipart) — https://help.shopify.com/en/manual/shopify-admin/productivity-tools/file-uploads
  const MAX_FOTO_BYTES = 10 * 1024 * 1024;

  // ==========================================================================

  class EternoConf {

    constructor() {
      this.data = {
        tipologia:    null,
        formato:      null,
        orientamento: 'Verticale',
        categoria:    'Religiosa',
        graficaId:    null,
        graficaName:  null,
        graficaImage: null,
        nome:         '',
        cognome:      '',
        nascita:      '',
        morte:        '',
        luogo:        '',
        parrocchia:   '',
        pensiero:     null,
        pensieroMode: 'lista',
        saluti:       '',
        quantita:     15,
        cNote:        '',
        privacy:      false,
        hasFoto:      false,
      };
      this.stepIndex    = 0;
      this._toastTimer  = null;
      this._urlGrafica  = null;
      this.init();
    }

    // ---- Step sequence -------------------------------------------------------

    get steps() {
      return ALL_STEPS;
    }

    get currentStep() { return this.steps[this.stepIndex]; }

    // ---- Init ----------------------------------------------------------------

    init() {
      const form = document.getElementById('ConfForm');
      if (!form) return;
      form.setAttribute('novalidate', '');

      this.bindRadios();
      this.bindCategoryTabs();
      this.bindGrafiche();
      this.bindFotoUpload();
      this.bindQty();
      this.bindPensieroTabs();
      this.bindLiveInputs();
      this.bindCheckoutInputs();
      this.bindNav();
      this.readUrlPreselect();

      if (this.loadFromStorage()) this.restoreFormFields();

      this.updateUI();
      this.updateBreadcrumb();
      this.updatePreview();
      this.updatePriceHint();
    }

    // ---- Event binding -------------------------------------------------------

    bindRadios() {
      document.querySelectorAll('input[type="radio"]').forEach(r => {
        r.addEventListener('change', () => this.onRadioChange(r));
      });
    }

    onRadioChange(radio) {
      const { name, value } = radio;

      if (name === 'tipologia') {
        if (this.data.formato !== null) {
          this.showToast('Tipologia cambiata: il formato è stato reimpostato.');
        }
        this.data.tipologia = value;
        document.querySelectorAll('.conf-formats').forEach(el => {
          el.classList.toggle('conf-hidden', el.dataset.tipologia !== value);
        });
        document.querySelectorAll('input[name="formato"]').forEach(r => { r.checked = false; });
        this.data.formato = null;
        const hint = document.getElementById('conf-formats-hint');
        if (hint) hint.style.display = 'none';
      }

      if (name === 'formato') {
        this.data.formato = value;
        this.updatePreviewFmtClass();
        this.updateGraficaImageForFormat();
        this.updatePriceHint();
      }

      if (name === 'pensiero-preset') this.data.pensiero = value;

      this.saveToStorage();
      this.updateBreadcrumb();
      this.updatePreview();
      this.updateLiveRecap();
    }

    bindCategoryTabs() {
      document.querySelectorAll('.conf-cattab').forEach(btn => {
        btn.addEventListener('click', () => {
          const cat = btn.dataset.cat;
          this.data.categoria = cat;

          document.querySelectorAll('.conf-cattab').forEach(b => {
            b.classList.toggle('conf-cattab--active', b.dataset.cat === cat);
          });
          document.querySelectorAll('.conf-grafiche').forEach(el => {
            el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
          });
          document.querySelectorAll('.conf-pensieri').forEach(el => {
            el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
          });

          if (this.data.graficaId) {
            this.showToast('Categoria cambiata: la grafica è stata reimpostata.');
          }
          this.data.graficaId = this.data.graficaName = this.data.graficaImage = null;
          this.data.pensiero  = null;
          document.querySelectorAll('.conf-grafica').forEach(c => c.classList.remove('is-selected'));
          document.querySelectorAll('input[name="pensiero-preset"]').forEach(r => { r.checked = false; });
          document.getElementById('sel-grafica-id').value   = '';
          document.getElementById('sel-grafica-name').value = '';
          this.updateParrocchiaField(cat);

          this.saveToStorage();
          this.updateBreadcrumb();
          this.updatePreview();
          this.updateLiveRecap();
        });
      });
    }

    bindFotoUpload() {
      const input = document.getElementById('foto-upload');
      if (!input) return;

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file || !file.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = e => {
          const card = document.getElementById('prev-front');
          if (!card) return;
          card.style.backgroundImage    = 'url("' + e.target.result + '")';
          card.style.backgroundSize     = 'cover';
          card.style.backgroundPosition = 'center';
          const ph = document.getElementById('prev-front-ph');
          if (ph) ph.style.display = 'none';
          this.data.hasFoto = true;
          this.saveToStorage();
        };
        reader.readAsDataURL(file);
      });
    }

    bindGrafiche() {
      document.querySelectorAll('.conf-grafica').forEach(card => {
        card.addEventListener('click', () => {
          document.querySelectorAll('.conf-grafica').forEach(c => c.classList.remove('is-selected'));
          card.classList.add('is-selected');
          this.data.graficaId    = card.dataset.id;
          this.data.graficaName  = card.dataset.name;
          this.data.graficaImage = this.getGraficaImage(card);
          this.data.orientamento = card.dataset.orientamento || 'Verticale';
          
          document.getElementById('sel-grafica-id').value   = card.dataset.id;
          document.getElementById('sel-grafica-name').value = card.dataset.name;
          this.updatePreview();
          this.updateBreadcrumb();
          this.updateLiveRecap();
          this.saveToStorage();
        });
      });
    }

    bindQty() {
      const input = document.getElementById('dr-qty');
      if (!input) return;
      const clamp = () => {
        input.value = Math.max(15, parseInt(input.value) || 15);
        this.data.quantita = parseInt(input.value);
        this.updatePriceHint();
        this.updateBreadcrumb();
        this.updateLiveRecap();
        this.saveToStorage();
      };
      document.getElementById('qty-minus').addEventListener('click', () => {
        input.value = Math.max(15, parseInt(input.value || 15) - 1);
        clamp();
      });
      document.getElementById('qty-plus').addEventListener('click', () => {
        input.value = parseInt(input.value || 15) + 1;
        clamp();
      });
      input.addEventListener('change', clamp);
    }

    bindPensieroTabs() {
      document.querySelectorAll('.conf-tab[data-mode]').forEach(btn => {
        btn.addEventListener('click', () => {
          const mode = btn.dataset.mode;
          this.data.pensieroMode = mode;
          document.querySelectorAll('.conf-tab[data-mode]').forEach(b => {
            b.classList.toggle('conf-tab--active', b.dataset.mode === mode);
          });
          document.getElementById('pan-lista').classList.toggle('conf-hidden', mode !== 'lista');
          document.getElementById('pan-libero').classList.toggle('conf-hidden', mode !== 'libero');
          if (mode === 'libero') {
            document.querySelectorAll('input[name="pensiero-preset"]').forEach(r => { r.checked = false; });
            this.data.pensiero = null;
          } else {
            document.getElementById('dr-pensiero-tx').value = '';
            this.data.pensiero = null;
          }
          this.updatePreview();
          this.saveToStorage();
        });
      });
    }

    bindLiveInputs() {
      [
        ['dr-nome',       'nome'],
        ['dr-cognome',    'cognome'],
        ['dr-nascita',    'nascita'],
        ['dr-morte',      'morte'],
        ['dr-luogo',      'luogo'],
        ['dr-parrocchia', 'parrocchia'],
        ['dr-saluti',     'saluti'],
      ].forEach(([id, key]) => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', () => {
          this.data[key] = el.value;
          this.updatePreview();
          this.updateLiveRecap();
          this.saveToStorage();
        });
      });

      const txPensiero = document.getElementById('dr-pensiero-tx');
      if (txPensiero) txPensiero.addEventListener('input', () => {
        if (this.data.pensieroMode === 'libero') {
          this.data.pensiero = txPensiero.value.trim() || null;
          this.updatePreview();
          this.updateLiveRecap();
          this.saveToStorage();
        }
      });
    }

    bindCheckoutInputs() {
      [
        ['c-note',    'cNote'],
      ].forEach(([id, key]) => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', () => {
          this.data[key] = el.value;
          this.updateLiveRecap();
          this.saveToStorage();
        });
      });
      const privacyEl = document.getElementById('c-privacy');
      if (privacyEl) privacyEl.addEventListener('change', () => {
        this.data.privacy = privacyEl.checked;
        this.saveToStorage();
      });
    }

    bindNav() {
      document.getElementById('conf-next').addEventListener('click', () => this.next());
      document.getElementById('conf-prev').addEventListener('click', () => this.prev());
      document.getElementById('conf-submit').addEventListener('click', () => this.addToCart());
    }

    // ---- Navigation ----------------------------------------------------------

    next() {
      if (!this.validate()) return;
      if (this.stepIndex < this.steps.length - 1) {
        this.stepIndex++;
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    prev() {
      if (this.stepIndex > 0) {
        this.stepIndex--;
        this.clearError();
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    _scrollToConf() {
      const el = document.getElementById('EternoConf');
      if (!el) return;
      const headerEl = document.querySelector('sticky-header') || document.querySelector('.shopify-section-group-header-group');
      const headerH = headerEl ? headerEl.offsetHeight : 0;
      const top = el.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // ---- Validation ----------------------------------------------------------

    validate() {
      const s   = this.currentStep;
      const err = msg => { this.showError(msg); return false; };

      if (s === 'tipo-formato') {
        if (!this.data.tipologia) return err('Selezioni una tipologia di ricordino.');
        if (!this.data.formato)   return err('Selezioni un formato.');
        this.clearError(); return true;
      }

      if (s === 'grafica') {
        if (!this.data.graficaId) return err('Selezioni una grafica per il retro.');
        const nascita = document.getElementById('dr-nascita').value;
        const morte   = document.getElementById('dr-morte').value;
        if (nascita && morte && new Date(nascita) >= new Date(morte)) {
          return err('La data di nascita deve essere precedente alla data di morte.');
        }
        const pensiero = this.data.pensieroMode === 'libero'
          ? document.getElementById('dr-pensiero-tx').value.trim()
          : this.data.pensiero;
        this.data.nome       = document.getElementById('dr-nome').value.trim();
        this.data.cognome    = document.getElementById('dr-cognome').value.trim();
        this.data.nascita    = nascita;
        this.data.morte      = morte;
        this.data.luogo      = document.getElementById('dr-luogo').value.trim();
        this.data.parrocchia = document.getElementById('dr-parrocchia').value.trim();
        this.data.saluti     = document.getElementById('dr-saluti').value.trim();
        this.data.pensiero   = pensiero || null;
        this.clearError(); return true;
      }

      if (s === 'checkout') {
        const qty = parseInt(document.getElementById('dr-qty').value);
        if (!qty || qty < 15) return err('La quantità minima è di 15 pezzi.');
        this.data.quantita = qty;

        const privacy = document.getElementById('c-privacy').checked;
        if (!privacy) return err('Per procedere è necessario accettare la Privacy Policy.');

        this.data.cNote     = document.getElementById('c-note').value.trim() || '';
        this.data.privacy   = privacy;
        this.clearError(); return true;
      }

      this.clearError();
      return true;
    }

    // ---- Error / Toast -------------------------------------------------------

    showError(msg) {
      const el = document.getElementById('conf-error');
      if (el) { el.textContent = msg; el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    }

    clearError() {
      const el = document.getElementById('conf-error');
      if (el) el.textContent = '';
    }

    showToast(msg, duration = 3500) {
      const el = document.getElementById('conf-toast');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('conf-toast--visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => el.classList.remove('conf-toast--visible'), duration);
    }

    // ---- Anteprima live ------------------------------------------------------

    updatePreview() {
      const d = this.data;

      if (d.formato && FORMAT_RATIO[d.formato]) {
        let r = FORMAT_RATIO[d.formato];
        if (d.orientamento === 'Orizzontale') r = 1 / r;
        document.querySelectorAll('.conf-preview__card').forEach(c => {
          c.style.aspectRatio = String(r);
        });
      }

      const backFace = document.getElementById('prev-back-face');
      if (backFace) backFace.classList.remove('conf-hidden');

      const imgDiv   = document.getElementById('prev-back-img');
      const noImgPh  = document.getElementById('prev-back-noimg');
      const overlay  = document.getElementById('prev-back-overlay');
      const hasImage = !!d.graficaImage;

      if (imgDiv) {
        if (hasImage) {
          let imgUrl = d.graficaImage;
          if (imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
          imgDiv.style.backgroundImage = 'url("' + imgUrl + '")';
        } else {
          imgDiv.style.backgroundImage = '';
        }
        if (noImgPh) noImgPh.classList.toggle('conf-hidden', hasImage);
        if (overlay) overlay.style.display = hasImage ? '' : 'none';
      }

      const nome    = [d.nome, d.cognome].filter(Boolean).join(' ') || 'Nome Cognome';
      const dateArr = [];
      if (d.nascita) dateArr.push(this.fmtDate(d.nascita));
      if (d.morte)   dateArr.push(this.fmtDate(d.morte));
      const dateStr  = dateArr.length === 2 ? dateArr.join(' – ') : (dateArr[0] || '');
      this._setText('prev-nome',  nome);
      this._setText('prev-dates', dateStr);
      this._setText('prev-luogo', d.luogo || '');

      const elParr = document.getElementById('prev-parrocchia');
      if (elParr) {
        elParr.textContent = d.parrocchia || '';
        elParr.classList.toggle('conf-hidden', !d.parrocchia);
      }

      const elSaluti = document.getElementById('prev-saluti');
      if (elSaluti) {
        elSaluti.textContent = d.saluti || '';
        elSaluti.classList.toggle('conf-hidden', !d.saluti || !hasImage);
      }

      const elDivider  = document.getElementById('prev-divider');
      const elPensiero = document.getElementById('prev-pensiero');
      if (elDivider)  elDivider.style.display = d.pensiero ? '' : 'none';
      if (elPensiero) elPensiero.textContent   = d.pensiero
        ? '«' + d.pensiero.substring(0, 90) + (d.pensiero.length > 90 ? '…' : '') + '»'
        : '';

      this._setText('prev-meta-fmt', d.formato   || '—');
      this._setText('prev-meta-tip', d.tipologia || '—');

      const previewCol = document.getElementById('conf-preview-col');
      const isReady    = !!(d.tipologia && d.formato);
      if (previewCol) previewCol.classList.toggle('conf-preview--waiting', !isReady);

      const hint = document.getElementById('prev-hint');
      if (hint) hint.style.display = isReady ? 'none' : '';
    }

    _setText(id, text) {
      const el = document.getElementById(id);
      if (el) el.textContent = text;
    }

    // ---- Parrocchia field label -----------------------------------------------

    updateParrocchiaField(categoria) {
      const label = document.querySelector('label[for="dr-parrocchia"]');
      const input = document.getElementById('dr-parrocchia');
      if (!label || !input) return;
      if (categoria === 'Religiosa') {
        label.childNodes[0].textContent = 'Parrocchia / Luogo della cerimonia';
        input.placeholder = 'es. Chiesa di San Giorgio…';
      } else {
        label.childNodes[0].textContent = 'Luogo della cerimonia';
        input.placeholder = 'es. Sala del Commiato, Cimitero Monumentale…';
      }
    }

    // ---- Price hint ----------------------------------------------------------

    updatePriceHint() {
      const el = document.getElementById('conf-price-hint');
      if (!el) return;
      const qty   = this.data.quantita || 15;
      const price = this._getPricePerPz();
      el.textContent = (price != null)
        ? 'Totale indicativo: €' + (qty * price).toFixed(2) + ' (' + qty + ' pz × €' + price.toFixed(2) + '/pz)'
        : '';
    }

    // ---- Breadcrumb ----------------------------------------------------------

    updateBreadcrumb() {
      const el = document.getElementById('conf-breadcrumb');
      if (!el) return;
      const d = this.data;
      const items = [
        d.tipologia,
        d.formato,
        d.orientamento === 'Orizzontale' && 'Orizzontale',
        d.categoria,
        d.graficaId && (d.graficaId + (d.graficaName ? ' · ' + d.graficaName : '')),
        d.quantita && d.quantita > 0 && (d.quantita + ' pz'),
      ].filter(Boolean);

      if (!items.length) { el.innerHTML = ''; return; }

      el.innerHTML = items.map((item, i) =>
        '<span class="conf-breadcrumb__item">' + item + '</span>' +
        (i < items.length - 1 ? '<span class="conf-breadcrumb__sep" aria-hidden="true">›</span>' : '')
      ).join('');
    }

    // ---- Live recap (checkout step) ------------------------------------------

    updateLiveRecap() {
      if (this.currentStep !== 'checkout') return;
      const inner = document.getElementById('conf-recap-inner');
      if (!inner) return;
      inner.innerHTML = this.buildRecapHTML();
    }

    buildRecapHTML() {
      const d     = this.data;
      const price = this._getPricePerPz();
      const est   = (price != null)
        ? '€' + (d.quantita * price).toFixed(2) + ' (' + d.quantita + ' pz × €' + price.toFixed(2) + '/pz)'
        : '—';
      let html = '';

      html += this.recapSection('Configurazione', [
        ['Tipologia',  d.tipologia],
        ['Formato',    d.formato],
        d.orientamento === 'Orizzontale' && ['Orientamento', 'Orizzontale'],
        d.categoria && ['Categoria',  d.categoria],
        d.graficaId && ['Grafica',    d.graficaId + (d.graficaName ? ' — ' + d.graficaName : '')],
        ['Quantità',   d.quantita + ' pz'],
        ['Totale',     est],
      ].filter(Boolean));

      const retroRows = [
        d.nome       && ['Nome',            d.nome],
        d.cognome    && ['Cognome',          d.cognome],
        d.nascita    && ['Data di nascita',  this.fmtDate(d.nascita)],
        d.morte      && ['Data di morte',    this.fmtDate(d.morte)],
        d.luogo      && ['Ved./Altro',       d.luogo],
        d.parrocchia && ['Parrocchia',       d.parrocchia],
        d.pensiero   && ['Pensiero',         d.pensiero, true],
        d.saluti     && ['Saluti',           d.saluti],
      ].filter(Boolean);
      if (retroRows.length) html += this.recapSection('Dati per il retro', retroRows);

      const contRows = [
        d.cNote  && ['Note',     d.cNote],
      ].filter(Boolean);
      if (contRows.length) html += this.recapSection('Note', contRows);

      return html;
    }

    recapSection(title, rows) {
      let dl = '<div class="conf-recap__section"><h3 class="conf-recap__heading">' + title + '</h3><dl class="conf-recap__list">';
      rows.forEach(row => {
        const [dt, dd, isPensiero] = row;
        if (!dd) return;
        dl += '<dt>' + this.esc(dt) + '</dt><dd' + (isPensiero ? ' class="conf-pensiero-val"' : '') + '>' + this.esc(String(dd)) + '</dd>';
      });
      return dl + '</dl></div>';
    }

    // ---- UI update -----------------------------------------------------------

    updateUI() {
      const steps   = this.steps;
      const current = this.currentStep;
      const total   = steps.length;
      const index   = this.stepIndex;

      document.querySelectorAll('.conf-step').forEach(el => {
        const active = el.dataset.step === current;
        el.classList.toggle('conf-step--active', active);
        el.style.display = active ? '' : 'none';
      });

      const pct = Math.round(((index + 1) / total) * 100);
      const fill = document.getElementById('conf-bar');
      if (fill) fill.style.width = pct + '%';
      this._setText('conf-bar-curr', index + 1);
      this._setText('conf-bar-tot',  total);

      const prevBtn   = document.getElementById('conf-prev');
      const nextBtn   = document.getElementById('conf-next');
      const submitBtn = document.getElementById('conf-submit');
      const isLast    = index === total - 1;

      prevBtn.disabled = index === 0;
      nextBtn.classList.toggle('conf-hidden',   isLast);
      submitBtn.classList.toggle('conf-hidden', !isLast);

      this.clearError();
      this.updateBreadcrumb();
      this.updatePreview();

      if (this.currentStep === 'grafica' && this._urlGrafica) this.applyUrlPreselect();
      if (isLast) this.updateLiveRecap();
    }

    // ---- Aggiungi al carrello ------------------------------------------------

    addToCart() {
      if (!this.validate()) return;

      const d   = this.data;
      // Ogni grafica è il prodotto Shopify vendibile: la variante si cerca
      // dentro la mappa di QUELLA grafica, chiave = variant.title reale
      // ("{Formato} / {Tipologia}", nell'ordine delle opzioni su Shopify).
      const key = d.formato + ' / ' + d.tipologia;
      const graficaMap    = window.EternoGrafiche && window.EternoGrafiche[d.graficaId];
      const variantEntry  = graficaMap && graficaMap[key];
      const variantId = variantEntry && variantEntry.id;
      if (!variantId) {
        this.showError('Configurazione non disponibile — controlli le scelte effettuate.');
        return;
      }

      const fotoInput = document.getElementById('foto-upload');
      const fotoFile  = fotoInput && fotoInput.files && fotoInput.files[0];
      if (fotoFile && fotoFile.size > MAX_FOTO_BYTES) {
        this.showError('La foto supera i 10 MB consentiti: scelga un file più leggero oppure la invii a ' +
          document.getElementById('EternoConf').dataset.email + ' dopo l\'ordine.');
        return;
      }

      const btn = document.getElementById('conf-submit');
      if (btn) { btn.disabled = true; btn.textContent = 'Invio in corso…'; }
      this.clearError();

      const props = {};
      if (d.nome)       props['Nome']           = d.nome;
      if (d.cognome)    props['Cognome']         = d.cognome;
      if (d.nascita)    props['Data di nascita'] = this.fmtDate(d.nascita);
      if (d.morte)      props['Data di morte']   = this.fmtDate(d.morte);
      if (d.luogo)      props['Vedovo/a di']     = d.luogo;
      if (d.parrocchia) props['Parrocchia']  = d.parrocchia;
      if (d.pensiero)   props['Pensiero']   = d.pensiero;
      if (d.saluti)     props['Saluti']     = d.saluti;
      if (d.orientamento === 'Orizzontale') props['Orientamento'] = 'Orizzontale';
      if (d.cNote)      props['Note']            = d.cNote;

      // Il file (se presente) è già collegato a #shopify-cart-form via
      // l'attributo form="shopify-cart-form" sull'input #foto-upload: Shopify
      // lo carica sul proprio CDN e lo lega alla riga d'ordine come
      // properties[Foto]. Questo richiede una submit di form reale — l'API
      // AJAX /cart/add.js non supporta upload di file.
      const form = document.getElementById('shopify-cart-form');
      form.querySelector('#scf-variant-id').value = variantId;
      form.querySelector('#scf-quantity').value   = d.quantita;
      const propsContainer = form.querySelector('#scf-properties');
      propsContainer.innerHTML = '';
      Object.entries(props).forEach(([k, v]) => {
        const input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'properties[' + k + ']';
        input.value = v;
        propsContainer.appendChild(input);
      });

      try { sessionStorage.removeItem(LS_KEY); } catch(_) {}
      form.submit();
    }

    // ---- sessionStorage (dati validi solo per la sessione del tab corrente) ----

    saveToStorage() {
      try {
        sessionStorage.setItem(LS_KEY, JSON.stringify({ data: this.data, stepIndex: this.stepIndex }));
      } catch(_) {}
    }

    loadFromStorage() {
      try {
        const raw = sessionStorage.getItem(LS_KEY);
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved || !saved.data) return false;
        Object.assign(this.data, saved.data);
        this.stepIndex = Math.min(saved.stepIndex || 0, this.steps.length - 1);
        return true;
      } catch(_) { return false; }
    }

    restoreFormFields() {
      const d = this.data;

      const setRadio = (name, val) => {
        if (!val) return;
        document.querySelectorAll(`input[name="${name}"]`).forEach(r => { r.checked = r.value === val; });
      };
      setRadio('tipologia', d.tipologia);
      setRadio('formato',   d.formato);

      const set = (id, val) => {
        if (val === null || val === undefined || val === '') return;
        const el = document.getElementById(id);
        if (el) el.value = val;
      };
      set('dr-nome',       d.nome);
      set('dr-cognome',    d.cognome);
      set('dr-nascita',    d.nascita);
      set('dr-morte',      d.morte);
      set('dr-luogo',      d.luogo);
      set('dr-parrocchia', d.parrocchia);
      set('dr-saluti',     d.saluti);
      set('c-note',        d.cNote);

      const cb = (id, val) => { const el = document.getElementById(id); if (el) el.checked = !!val; };
      cb('c-privacy',   d.privacy);

      const cat = d.categoria || 'Religiosa';
      document.querySelectorAll('.conf-cattab').forEach(b => {
        b.classList.toggle('conf-cattab--active', b.dataset.cat === cat);
      });
      document.querySelectorAll('.conf-grafiche').forEach(el => {
        el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
      });
      document.querySelectorAll('.conf-pensieri').forEach(el => {
        el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
      });

      if (d.graficaId) {
        document.querySelectorAll('.conf-grafica').forEach(c => {
          const match = c.dataset.id === d.graficaId;
          c.classList.toggle('is-selected', match);
          if (match) d.graficaImage = this.getGraficaImage(c);
        });
        set('sel-grafica-id',   d.graficaId);
        set('sel-grafica-name', d.graficaName);
      }

      const mode = d.pensieroMode || 'lista';
      document.querySelectorAll('.conf-tab[data-mode]').forEach(b => {
        b.classList.toggle('conf-tab--active', b.dataset.mode === mode);
      });
      document.getElementById('pan-lista')?.classList.toggle('conf-hidden',  mode !== 'lista');
      document.getElementById('pan-libero')?.classList.toggle('conf-hidden', mode !== 'libero');
      if (mode === 'libero' && d.pensiero) {
        set('dr-pensiero-tx', d.pensiero);
      } else if (d.pensiero) {
        document.querySelectorAll('input[name="pensiero-preset"]').forEach(r => { r.checked = r.value === d.pensiero; });
      }

      if (d.tipologia) {
        const hint = document.getElementById('conf-formats-hint');
        if (hint) hint.style.display = 'none';
        document.querySelectorAll('.conf-formats').forEach(el => {
          el.classList.toggle('conf-hidden', el.dataset.tipologia !== d.tipologia);
        });
      }

      const qtyInput = document.getElementById('dr-qty');
      if (qtyInput && d.quantita) qtyInput.value = d.quantita;

      if (d.hasFoto) {
        const ph  = document.getElementById('prev-front-ph');
        const spn = ph && ph.querySelector('span');
        if (spn) spn.textContent = 'Carichi di nuovo la foto';
        if (ph)  ph.style.display = '';
      }

      this.updatePreviewFmtClass();
    }

    // ---- URL pre-selezione grafica -------------------------------------------

    readUrlPreselect() {
      this._urlGrafica = new URLSearchParams(window.location.search).get('grafica') || null;
    }

    applyUrlPreselect() {
      const id = this._urlGrafica;
      if (!id) return;

      const safeId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id;
      const card   = document.querySelector('.conf-grafica[data-id="' + safeId + '"]');
      if (!card) return;

      // Attiva la categoria corretta se necessario
      const container = card.closest('.conf-grafiche');
      const cat        = container ? container.dataset.categoria : null;
      if (cat && cat !== this.data.categoria) {
        this.data.categoria = cat;
        document.querySelectorAll('.conf-cattab').forEach(b => {
          b.classList.toggle('conf-cattab--active', b.dataset.cat === cat);
        });
        document.querySelectorAll('.conf-grafiche').forEach(el => {
          el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
        });
        document.querySelectorAll('.conf-pensieri').forEach(el => {
          el.classList.toggle('conf-hidden', el.dataset.categoria !== cat);
        });
        this.updateParrocchiaField(cat);
      }

      // Seleziona il card
      document.querySelectorAll('.conf-grafica').forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      this.data.graficaId    = id;
      this.data.graficaName  = card.dataset.name;
      this.data.graficaImage = this.getGraficaImage(card);
      this.data.orientamento = card.dataset.orientamento || 'Verticale';

      document.getElementById('sel-grafica-id').value   = id;
      document.getElementById('sel-grafica-name').value = card.dataset.name;

      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      this._urlGrafica = null; // consuma una volta sola

      this.updatePreview();
      this.updateBreadcrumb();
      this.saveToStorage();
    }

    // ---- Preview font scale per gruppo formato --------------------------------

    updatePreviewFmtClass() {
      const col = document.getElementById('conf-preview-col');
      if (!col) return;
      col.classList.remove('conf-preview--fmt-sm', 'conf-preview--fmt-md');
      const cls = FORMAT_SIZE_CLASS[this.data.formato];
      if (cls) col.classList.add(cls);
    }

    // ---- Immagine grafica per formato corrente --------------------------------

    formatToKey(fmt) {
      return fmt ? fmt.replace('×', 'x').replace(' cm', '').replace(/\s/g, '') : '';
    }

    getGraficaImage(card) {
      const key = this.formatToKey(this.data.formato);
      return (key && card.dataset['img' + key]) || null;
    }

    updateGraficaImageForFormat() {
      if (!this.data.formato) return;
      const key = this.formatToKey(this.data.formato);

      document.querySelectorAll('.conf-grafica').forEach(card => {
        const imgUrl = key ? card.dataset['img' + key] : null;
        if (!imgUrl) return;
        const img = card.querySelector('img.conf-grafica__thumb');
        if (img) {
          img.src = imgUrl;
        } else {
          const ph = card.querySelector('.conf-grafica__thumb--noimg');
          if (ph) {
            const newImg      = document.createElement('img');
            newImg.className  = 'conf-grafica__thumb';
            newImg.src        = imgUrl;
            newImg.alt        = card.dataset.name || '';
            newImg.loading    = 'lazy';
            newImg.width      = 300;
            newImg.height     = 450;
            ph.parentNode.replaceChild(newImg, ph);
          }
        }
      });

      // Aggiorna graficaImage se c'è una grafica già selezionata
      const selected = document.querySelector('.conf-grafica.is-selected');
      if (selected) {
        this.data.graficaImage = this.getGraficaImage(selected);
        this.updatePreview();
      }
    }

    // ---- Helpers -------------------------------------------------------------

    _getPricePerPz() {
      const d = this.data;
      if (!d.tipologia || !d.formato) return null;
      const key = d.formato + ' / ' + d.tipologia;
      const all = window.EternoGrafiche || {};
      // Il prezzo dipende solo da tipologia+formato, mai dalla grafica: se
      // non è ancora stata scelta, si legge da una grafica qualsiasi come
      // stima (tutte condividono lo stesso listino, sincronizzato da
      // sync-grafiche.py) — è comunque il prezzo reale, non un fallback.
      const graficaMap = (d.graficaId && all[d.graficaId]) || all[Object.keys(all)[0]];
      const entry = graficaMap && graficaMap[key];
      return (entry && typeof entry.price === 'number') ? entry.price : null;
    }

    fmtDate(str) {
      if (!str) return '—';
      const [y, m, g] = str.split('-');
      return g + '/' + m + '/' + y;
    }

    esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  }

  // ==========================================================================
  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('ConfForm')) new EternoConf();
  });

})();
